import browserClient from '@apmplus/web';

import { isVacuous } from '@yimoka/shared';

import { ENV } from '@/env';

export const initApm = () => {
  if (!isVacuous(ENV.apm) && ENV.apm.token) {
    browserClient('init', ENV.apm);
    browserClient('start');
  }
};
